import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { AdminNotFoundContainer } from '../../containers/AdminNotFoundContainer';

export const AdminNotFoundPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<AdminNotFoundContainer />
		</AdminDashboardPageLayout>
	);
};
